"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Translator_1 = require("../Translator");
/**
 * Translates double numbers.
 */


var TypeHandlerNumberDouble =
/*#__PURE__*/
function () {
  function TypeHandlerNumberDouble() {
    _classCallCheck(this, TypeHandlerNumberDouble);
  }

  _createClass(TypeHandlerNumberDouble, [{
    key: "fromRdf",
    value: function fromRdf(literal, validate) {
      var parsed = parseFloat(literal.value);

      if (validate) {
        if (isNaN(parsed)) {
          Translator_1.Translator.incorrectRdfDataType(literal);
        } // TODO: validate more

      }

      return parsed;
    }
  }, {
    key: "toRdf",
    value: function toRdf(value, dataFactory) {
      if (isNaN(value)) {
        return dataFactory.literal('NaN', dataFactory.namedNode(TypeHandlerNumberDouble.TYPES[0]));
      }

      if (!isFinite(value)) {
        return dataFactory.literal(value > 0 ? 'INF' : '-INF', dataFactory.namedNode(TypeHandlerNumberDouble.TYPES[0]));
      }

      if (value % 1 === 0) {
        return null;
      }

      return dataFactory.literal(value.toExponential(15).replace(/(\d)0*e\+?/, '$1E'), dataFactory.namedNode(TypeHandlerNumberDouble.TYPES[0]));
    }
  }]);

  return TypeHandlerNumberDouble;
}();

TypeHandlerNumberDouble.TYPES = ['http://www.w3.org/2001/XMLSchema#double', 'http://www.w3.org/2001/XMLSchema#decimal', 'http://www.w3.org/2001/XMLSchema#float'];
exports.TypeHandlerNumberDouble = TypeHandlerNumberDouble;